import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import { makeStyles } from '@material-ui/core/styles';

import Auth from '../../hoc/Auth';
import usePod from '../../hooks/pods';
import Loading from '../../components/loading/Loading';
import MachineLogo from '../../icons/MachineLogo';

const useStyles = makeStyles((theme) => ({
	container: {
		color: 'white',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '20px 0',
		minHeight: 'inherit',
	},
	header: {
		fontWeight: 'bold',
		fontSize: '18px',
		textAlign: 'center',
		'& .MuiIcon-root': {
			fontSize: '34px',
		},
	},
	mainContainer: {
		textAlign: 'center',
		fontWeight: 'bold',
		textTransform: 'capitalize',
		fontSize: '20px',
		marginBottom: '20px',
		flex: '1 100%',
		padding: '0 20px',
		display: 'flex',
		flexDirection: 'column',
		'& figure': {
			margin: 0,
			width: '100%',
			flex: 1,
			display: 'flex',
			alignItems: 'center',
			'& img': {
				width: '100%',
				height: 'auto',
				maxHeight: '60vh',
				objectFit: 'contain'
			},
		},
	},
	footer: {
		display: 'flex',
		flexDirection: 'column',
		'& .MuiButton-contained': {
			borderRadius: '2px',
		},
	},
	confirmBtn: {
		borderRadius: '4px',
		backgroundColor: '#bedc13',
		color: 'black',
		fontSize: '12px',
		width: '90px',
		marginBottom: '10px',
		'&:hover': {
			backgroundColor: '#bedc13',
		},
	},
	changeBtn: {
		textTransform: 'lowercase',
		color: 'white',
	},
}));

const ConfirmMachine = ({ history, location }) => {
	const classes = useStyles();
	const [{ pods = [], selectedPod, fetching: fetchingPod, error: errorPod }, handleSelectPod, , , fetchPods] = usePod();

	const [machineStatus, setMachineStatus] = useState('PENDING');
	const [selPod, setSelPod] = useState(null);
	useEffect(() => {
		const { state: { selectPod = '' } = {} } = location;
		if (pods && pods.length > 0 && selectPod && (!selectedPod || selectPod !== selectedPod.vm_imei_id)) {
			const pod = pods.find((pod) => pod.vm_imei_id === selectPod);
			if (pod) {
				setSelPod(pod);
				setMachineStatus('FOUND');
			} else {
				setMachineStatus('NOT_FOUND');
			}
			history.replace({ ...location, state: {} });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pods]);

	useEffect(() => {
		const { state: { selectPod = '' } = {} } = location;
		if (!selectPod) {
			history.replace('/podlist');
		} else {
			fetchPods();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const changeLocation = () => {
		history.replace('/podlist');
	};

	const confirmPod = () => {
		handleSelectPod(selPod);
		history.replace('/products');
	};

	return (
		<section className={classes.container}>
			{fetchingPod ? (
				<Loading message='Loading nearby machines' style={{ color: 'white' }} />
			) : errorPod ? (
				<section
					style={{
						color: 'white',
						fontSize: '14px',
						minHeight: 'inherit',
						textAlign: 'center',
						display: 'flex',
						alignItems: 'center',
						padding: '1px',
						justifyContent: 'center',
					}}
				>
					<div>
						Error while fetching machines. <br />
						Please refresh or try again later.
					</div>
				</section>
			) : (
				<>
					<header className={classes.header}>
						<Icon>edit_location</Icon>
						<h1> Confirm VendingBuddy Location</h1>
					</header>
					<main className={classes.mainContainer}>
						<figure>
							<MachineLogo />
						</figure>
						{machineStatus === 'FOUND' ? (
							<section>{selPod.location}</section>
						) : (
							<section>Machine no longer exits</section>
						)}
					</main>
					<footer className={classes.footer}>
						<Button
							aria-label='confirm'
							variant='contained'
							classes={{ contained: classes.confirmBtn }}
							onClick={confirmPod}
						>
							{machineStatus === 'FOUND' ? 'confirm' : 'Search'}
						</Button>
						{machineStatus === 'FOUND' && (
							<Button aria-label='change' classes={{ root: classes.changeBtn }} onClick={changeLocation}>
								change
							</Button>
						)}
					</footer>
				</>
			)}
		</section>
	);
};

export default Auth(ConfirmMachine);
